import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { MatTableDataSource } from '@angular/material/table';
import { CourseService } from '../../services/course.service';

@Component({
    selector: 'app-related-course-listing',
    imports: [CommonModule, SharedModule],
    templateUrl: './related-course-listing.component.html',
    styleUrl: './related-course-listing.component.css'
})
export class RelatedCourseListingComponent implements OnInit {
  @Input() relatedCourseMatData: any = null;
  @Input() relatedCourseData: any = [];
  @Output() openAddRelatedCourse = new EventEmitter<any>();
  @Output() loadRelatedCourseData = new EventEmitter<any>();
  courseService = inject(CourseService);
  relatedCourseColumns: string[] = ['institutionName', 'qualificationType', 'courseInstanceTitle', 'status', 'menu'];
  relatedCourseList: any = null;
  linkRelatedCourseData: any = null;

  ngOnInit(): void {
    this.relatedCourseList = new MatTableDataSource(this.relatedCourseData);
  }

  openRelatedCoursePopup(pageType: string, relatedCourseId?: any) {
    if (this.relatedCourseMatData?.pageName?.includes('view') && pageType === 'add')
      return
    const pageDetails = { pageType, relatedCourseId }
    this.openAddRelatedCourse.emit(pageDetails);
  }

  showAlertPopup(relCourse: any) {
    document.getElementById('alert_popup')?.scrollIntoView({ behavior: "smooth", block: "start" });
    this.linkRelatedCourseData = relCourse;
  }

  linkOrUnlinkCourse() {
    const linkStatus = (this.linkRelatedCourseData.status?.toLowerCase() === 'unlinked') ? 'reLink' : 'unLink';
    this.courseService.linkOrUnlinkRelatedCourse(this.relatedCourseMatData.institutionId, this.relatedCourseMatData.courseId, this.relatedCourseMatData.courseInstanceId, this.linkRelatedCourseData.pathwayCourseInstanceRelationshipId, linkStatus)?.subscribe({
      next: (res: any) => {
        if (res?.message === "Successful response") {
          const successMsg = 'The course instance ' + this.linkRelatedCourseData.courseInstanceTitle + ' is successfully ' + ((linkStatus === 'reLink') ? 'linked' : 'unlinked');
          this.loadRelatedCourseData.emit({ success: successMsg });
        }
      },
      error: (err: Error) => console.log('link/unlink related course data', err.message)
    })
  }
}
